import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Clock, AlertCircle } from 'lucide-react';

const UrgencySection = () => {
  return (
    <section data-testid="urgency-section" className="section-padding bg-[#EDE7E1]">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          {/* Icon */}
          <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-[#C8A96A] flex items-center justify-center animate-pulse">
            <Clock className="w-10 h-10 text-white" />
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#111111] text-white px-6 py-2 rounded-full mb-8">
            <AlertCircle className="w-4 h-4" />
            <span className="text-sm font-bold tracking-wider uppercase">Unidades limitadas</span>
          </div>

          {/* Headline */}
          <h2 
            data-testid="urgency-headline"
            className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-[#111111] mb-6"
          >
            Colecciones con unidades limitadas
          </h2>

          {/* Description */}
          <p className="font-sans text-xl text-[#111111]/70 mb-10 max-w-2xl mx-auto leading-relaxed">
            En las colecciones outlet las tallas vuelan.<br />
            <span className="font-bold text-[#111111]">No dejes escapar tu prenda favorita.</span>
          </p>

          {/* CTA */}
          <a 
            href="https://styleoutlet.es/28-top-ventas" 
            target="_blank" 
            rel="noopener noreferrer"
            data-testid="urgency-cta"
          >
            <Button className="bg-[#C8A96A] hover:bg-[#111111] text-white px-12 py-7 text-lg font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer shadow-lg hover:shadow-xl">
              Ver colección antes de que se agote
              <ArrowRight className="ml-3 w-6 h-6" />
            </Button>
          </a>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-12 pt-8 border-t border-[#111111]/10">
            <div className="flex items-center gap-2 text-[#111111]/60">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
              <span className="text-sm font-sans">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2 text-[#111111]/60">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
              </svg>
              <span className="text-sm font-sans">Envío rápido</span>
            </div>
            <div className="flex items-center gap-2 text-[#111111]/60">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
              </svg>
              <span className="text-sm font-sans">Devolución fácil</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UrgencySection;
